import {BaseIntDTO} from '../_baseIntDTO.interface';

export interface LookupIntStringDTO {
  id: number;
  lookupValue: string;
}
